import type { PropsWithChildren } from 'react';
import type React from 'react';

import { useLoadGooglePlaces } from '../hooks/useLoadGooglePlaces';

import { GooglePlacesContextProvider } from './context';

export const GooglePlacesProvider: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const { status, autocompleteService, placesService } = useLoadGooglePlaces();

	return (
		<GooglePlacesContextProvider
			status={status}
			autocompleteService={autocompleteService}
			placesService={placesService}
		>
			{children}
		</GooglePlacesContextProvider>
	);
};
